import React, { useState } from "react";
import { useLocale } from './LocaleProvider';

export default function PasswordSetup({ email, required, onClose, onSent }) {
  const { locale } = useLocale();
  const es = locale === 'es';
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  async function requestReset() {
    setBusy(true);
    setMessage("");
    try {
      const response = await fetch("/api/auth/request-password-reset", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(es ? 'No fue posible enviar el enlace.' : (payload.error || "Não foi possível enviar o link."));
      setMessage(es ? 'Enviamos un enlace a tu correo. Ábrelo para crear la contraseña.' : "Enviamos um link para seu e-mail. Abra-o para criar sua senha.");
      onSent?.();
    } catch (error) {
      setMessage(es ? 'No fue posible enviar el enlace. Inténtalo de nuevo.' : error.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fixed inset-0 z-[70] flex min-h-dvh items-start justify-center overflow-y-auto bg-[rgba(23,58,84,0.5)] p-4 sm:items-center sm:p-6" role="dialog" aria-modal="true" aria-labelledby="password-setup-title">
      <div className="relative my-auto max-h-[calc(100dvh-2rem)] w-full max-w-md overflow-y-auto sheet p-6 sm:max-h-[calc(100dvh-3rem)] sm:p-7">
        <p className="text-xs font-semibold text-[var(--text-muted)]">{es ? 'Seguridad de la cuenta' : 'Segurança da conta'}</p>
        <h2 id="password-setup-title" className="mt-3 text-2xl font-semibold text-[var(--primary)]">{es ? 'Crea una contraseña para iniciar sesión sin usar OTP' : 'Crie uma senha para entrar sem consumir OTP'}</h2>
        <p className="mt-3 text-sm leading-relaxed text-[var(--text-muted)]">{es ? 'Una contraseña protege tu cuenta y evita recibir un nuevo código por correo en cada inicio de sesión.' : 'Uma senha protege o acesso à sua conta e evita o envio de um novo código por e-mail a cada login.'}</p>
        {message ? (
          <p role="status" className="mt-5 rounded-xl bg-[var(--background)] p-4 text-sm text-[var(--primary)]">{message}</p>
        ) : (
          <button type="button" disabled={busy} onClick={requestReset} className="mt-6 w-full rounded-xl bg-[var(--accent)] p-3 font-bold text-[var(--on-accent)] disabled:opacity-60">{busy ? (es ? 'Enviando enlace…' : 'Enviando link…') : (es ? 'Crear mi contraseña' : 'Criar minha senha')}</button>
        )}
        {!required && <button type="button" onClick={onClose} className="mt-3 w-full rounded-xl border border-[var(--border)] p-3 font-bold text-[var(--primary)]">{es ? 'Ahora no' : 'Agora não'}</button>}
      </div>
    </div>
  );
}
